/* ================================================== */
/* EMBEDS → article
/* ================================================== */

$(document).ready(function() {

	$('#article .type-video .embed').each(function(i){
		var iframe = $(this).find('iframe'),
			ratio  = String(iframe.attr('width')) + ':' + String(iframe.attr('height'));
		$(this).attr('data-ratio', ratio);
	});

});